import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import axios from "axios";
import Header from "../../Components/Header/header";
import MainPage from "../../Pages/MainPage/mainpage";
import Shop from "../Shop/shop";
import ShoppingCart from "../../Pages/ShoppingCart/shoppingcart";
import Admin from "../../Pages/AdminPage/admin";
import AdminStore from "../AdminStore/adminstore";
import Users from "../../Pages/UserPage/user";
import UserStore from "../UserStore/userstore";
import Login from "../Login/login";
import Register from "../Register/register";
import ShippingDetails from "../ShippingDetails/shippingdetails";
import Navbar from "../../Components/Navbar/navbar";
import UnderConstruction from "../../Components/UnderConstruction/underConstruction";
import AuthService from "../../Components/Auth/authservice";
import "./Landing.css";

const dbRequests = `http://localhost:5000/auth/verify`;

const Auth = new AuthService();

const AdminRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      Auth.adminLoggedIn() === true ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

const UserRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      Auth.userLoggedIn() === true ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

class Landing extends Component {
  state = {
    isLoggedIn: false
  };

  handleLogin = status => {
    this.setState({ isLoggedIn: status });
  };

  handleAdmin = status => {
    this.setState({ setAdmin: status });
  };

  checkJWT = () => {
    const localJWT = localStorage.getItem("jwt");
    console.log("Component will update: " + this.state);
    if (!localJWT) this.handleLogin(false);
    else {
      axios
        .get(dbRequests, { headers: { jwt: localJWT } })
        .then(response => {
          const { tokenIsValid } = response.data;
          if (tokenIsValid) this.handleLogin(true);
          else this.handleLogin(false);
        })
        .catch(err => {
          console.log(err);
          this.handleLogin(false);
        });
    }
  };

  render() {
    const { isLoggedIn } = this.state;
    return (
      <div className="Container">
        <div className="App">
          <Navbar isLoggedIn={isLoggedIn} />
          <Switch>
            <Route
              exact
              path="/"
              render={props => (
                <MainPage
                  {...props}
                  isLoggedIn={isLoggedIn}
                  isTest={this.checkJWT}
                  handleLogin={this.handleLogin}
                />
              )}
            />
            <Route path="/shop" render={props => <Shop {...props} />} />
            <Route
              exact
              path="/underconstruction"
              component={UnderConstruction}
            />
            <Route
              path="/login"
              render={props => (
                <Login
                  {...props}
                  handleAdmin={this.handleAdmin}
                  isLoggedIn={isLoggedIn}
                  handleLogin={this.handleLogin}
                />
              )}
            />
            <Route
              path="/register"
              render={props => (
                <Register
                  {...props}
                  isLoggedIn={isLoggedIn}
                  handleLogin={this.handleLogin}
                />
              )}
            />
            <Route
              path="/shoppingcart"
              render={props => (
                <ShoppingCart
                  {...props}
                  isLoggedIn={isLoggedIn}
                  handleLogin={this.handleLogin}
                />
              )}
            />
            <Route
              path="/shippingdetails"
              render={props => (
                <ShippingDetails
                  {...props}
                  isLoggedIn={isLoggedIn}
                  handleLogin={this.handleLogin}
                />
              )}
            />
            <AdminRoute
              exact
              path="/admin"
              render={props => (
                <Admin
                  {...props}
                  isLoggedIn={isLoggedIn}
                  handleLogin={this.handleLogin}
                />
              )}
            />
            <AdminRoute
              path="/adminstore"
              render={props => (
                <AdminStore
                  {...props}
                  isLoggedIn={isLoggedIn}
                  handleLogin={this.handleLogin}
                />
              )}
            />
          </Switch>
        </div>
      </div>
    );
  }
}

export default Landing;
